import { Navigate, Outlet } from 'react-router-dom';

import { LoadingSpinner, Page } from '../../../components';
import { useExamCard, useExamEvent, useNetwork } from '../../../providers';
import { PATHS } from '../../../routes';

// Main component for all routes under `/preview`
export function ProtectedExamPreviewRoute() {
  //   const { examCard, loading: isExamCardLoading } = useExamCard();

  //   const [startExam, { loading: isStartExamLoading }] = useStartExam({
  //     variables: {
  //       input: {
  //         examCardId: examCard?.id ?? '',
  //         isSetTimer: true,
  //       },
  //     },
  //   });

  //   const [backToExamRoom, { loading: isBackToExamRoomLoading }] = useBackToExamRoom({
  //     variables: {
  //       input: {
  //         examCardId: examCard?.id ?? '',
  //         isReset: false,
  //       },
  //     },
  //   });

  //   const { loading: isCheckExamStatusLoading } = useCheckExamStatusByCardId({
  //     variables: {
  //       examCardId: examCard?.id ?? '',
  //     },
  //     skip: !examCard?.id || isExamCardLoading,
  //     onCompleted: (data) => {
  //       if (!data.erCheckExamStatusByExamCardId?.id) {
  //         startExam();
  //       } else {
  //         backToExamRoom();
  //       }
  //     },
  //     onError: () => {
  //       // TODO: Navigate to error path
  //       // navigate(PATHS.Error);
  //     },
  //   });

  //   if (isCheckExamStatusLoading || isStartExamLoading || isBackToExamRoomLoading) {
  //     return (
  //       <div className='grid h-dvh w-screen place-items-center'>
  //         <LoadingSpinner />
  //       </div>
  //     );
  //   }

  // All routes under `/preview` will be inside `<Page />`
  return (
    <Page containerClassName='flex flex-col'>
      <Outlet />
    </Page>
  );
}

interface ProtectedExamEventPreviewRouteProps {
  children: React.ReactNode;
}

export function ProtectedExamEventPreviewRoute({
  children,
}: Readonly<ProtectedExamEventPreviewRouteProps>) {
  const { loading: isLoadingExamEvent, error: examEventError } = useExamEvent();
  const { loading: isLoadingExamCard, error: examCardError } = useExamCard();
  const { isOnline } = useNetwork();

  if (isLoadingExamEvent || isLoadingExamCard) {
    return (
      <div className='grid h-dvh w-screen place-items-center'>
        <LoadingSpinner />
      </div>
    );
  }

  if (examEventError || examCardError) {
    if (isOnline) {
      return <Navigate replace to={PATHS.Home} />;
    }
  }

  return children;
}
